import { Box, Text } from '@rsos/components/capstone/base';

/**
 * Most recent location's reverse geocoded address provider.
 * @param {String} rgAddressProvider - Reverse geocoded address provider
 */
const LocationAddressProvider = ({ rgAddressProvider }) => (
  <Box data-name="location-address-provider" marginTop="5px">
    <Text color="secondaryText" size="xsmall">
      <span>Estimated address </span>
      {rgAddressProvider ? <span>from {rgAddressProvider} </span> : ''}
      <span>| VERIFY with caller</span>
    </Text>
  </Box>
);

export default LocationAddressProvider;
